module.exports = __webpack_public_path__ + "img/v1.ac126e9.png";